import firebase from 'firebase/app';
import 'firebase/database';

export function getCompaniesFor(userUID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("usernameCompanies").child(userUID).child("companyID").once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching user data:", errorMessage);
            reject(error)
        });

    });     

}

export function getCompanyInfoFor(companyID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("company").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching user data:", errorMessage);
            reject(error)
        });

    });     

}

export function getEndUserInfoWith(userUID, companyID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("users").child(companyID).child(userUID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching user data:", errorMessage);
            reject(error)
        });

    });     

}

export function getAllCommunity(companyID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("community").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching user data:", errorMessage);
            reject(error)
        });

    });     

}

export function getRegions(companyID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("region").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching user data:", errorMessage);
            reject(error)
        });

    });     

}

export function getRewards(companyID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("rewards").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching user data:", errorMessage);
            reject(error)
        });

    });     

}

export function getActingAs(companyID) {
    
    return new Promise((resolve, reject) => {

        firebase.database().ref().child("actingAs").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching acting as data:", errorMessage);
            reject(error)
        });

    });     

}

export function getClientRegistrationRules(companyID){

    return new Promise((resolve, reject) => {

        firebase.database().ref().child("clientRegistrationRules").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching client registration rules data:", errorMessage);
            reject(error)
        });

    });     

}

export function getOperatingStates(companyID){

    return new Promise((resolve, reject) => {

        firebase.database().ref().child("operatingStates").child(companyID).once('value').then(snapshot => {

            resolve(snapshot.val())
            
        }).catch(function(error) {
            var errorMessage = error.message;
            console.log("Error fetching operating states data:", errorMessage);
            reject(error)
        });

    });     

}


// WEBPACK FOOTER //
// ./src/API/FirebaseManager.js